/**
 * Formata um CPF no padrão brasileiro (XXX.XXX.XXX-XX)
 * @param cpf - CPF a ser formatado (pode conter caracteres não numéricos)
 * @returns CPF formatado ou o valor original se inválido
 */
export const formatCPF = (cpf: string): string => {
  if (!cpf) {
    return '-';
  }

  const cleanCPF = cpf.replace(/\D/g, '');

  if (cleanCPF.length !== 11) {
    return cpf;
  }

  return cleanCPF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

/**
 * Formata um CNPJ no padrão brasileiro (XX.XXX.XXX/XXXX-XX)
 * @param cnpj - CNPJ a ser formatado (pode conter caracteres não numéricos)
 * @returns CNPJ formatado ou o valor original se inválido
 */
export const formatCNPJ = (cnpj: string): string => {
  if (!cnpj) {
    return '-';
  }

  const cleanCNPJ = cnpj.replace(/\D/g, '');

  if (cleanCNPJ.length !== 14) {
    return cnpj;
  }

  return cleanCNPJ.replace(
    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    '$1.$2.$3/$4-$5'
  );
};
